import { DashboardFiltrosComponent } from '../../../componentes/dashboard-filtros/dashboard-filtros.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { DashboardGeneralComponent } from './dashboard-general.component';
import { GraficosComponent } from '../../../auxiliares/graficos/graficos.component';
import { DashboardGeneralRoutingModule } from './routing';
import { InformeDiarioLuminariasComponent } from '../luminarias/dashboard-luminarias/informe-diario/informe-diario-luminarias.component';

@NgModule({
  declarations: [DashboardGeneralComponent],
  imports: [
    CommonModule,
    AuxiliaresModule,
    GraficosComponent,
    DashboardFiltrosComponent,
    DashboardGeneralRoutingModule,
    InformeDiarioLuminariasComponent,
  ],
  exports: [DashboardGeneralComponent],
})
export class DashboardGeneralModule {}
